import { ObjectType } from 'type-graphql'
import { Scope } from '../base'

@ObjectType()
export class NotificationScope extends Scope {}
